"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LabelContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelContainer = _styledComponents.default.label.withConfig({
  displayName: "FormLabel__LabelContainer",
  componentId: "sc-15obqve-0"
})(["color:", ";font-weight:600;font-size:1.4rem;display:block;margin-bottom:0.7rem;", ";"], function (props) {
  return props.theme.grey3;
}, function (_ref) {
  var required = _ref.required;
  return required && (0, _styledComponents.css)(["&:after{content:'*';margin-left:0.5rem;color:", ";}"], function (props) {
    return props.theme.red;
  });
});

exports.LabelContainer = LabelContainer;

var FormLabel = function FormLabel(_ref2) {
  var required = _ref2.required,
      labelTitle = _ref2.labelTitle;
  return /*#__PURE__*/_react.default.createElement(LabelContainer, {
    required: required
  }, labelTitle);
};

FormLabel.propTypes = {
  labelTitle: _propTypes.default.string.isRequired,
  required: _propTypes.default.bool
};
var _default = FormLabel;
exports.default = _default;